export default __webpack_public_path__ + "static/media/CAPABILITY_PD.6eb8152c.png";